import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function Caminho() {
  const { t } = useTranslation();

  const etapas = [
    t("nos.caminho.topicos.t1"),
    t("nos.caminho.topicos.t2"),
    t("nos.caminho.topicos.t3"),
    t("nos.caminho.topicos.t4")
  ];

  const [etapaAtual, setEtapaAtual] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setEtapaAtual((prev) => (prev + 1) % etapas.length);
    }, 2000);

    return () => clearInterval(intervalo);
  }, [etapas.length]);

  return (
    <section id="caminho_section">
      <h1>{t("nos.caminho.titulo")}</h1>
      <div className="caminho-container">
        <p dangerouslySetInnerHTML={{ __html: t("nos.caminho.descricao") }} />
        <div className="linha-fluxo">
          {etapas.map((etapa, index) => (
            <React.Fragment key={index}>
              <div className={`etapa ${etapaAtual === index ? "ativa" : ""}`}>
                {etapa}
              </div>
              {index < etapas.length - 1 && (
                <div className="seta">
                  <span>→</span>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
